export default {
  name: 'marking--reportUsageType',
};